export const PRICING_SEGMENT_LOCAL = "LOCAL";
export const PRICING_SEGMENT_DIASPORA = "DIASPORA";

const SEGMENT_KEY = "pricingSegment";
const COUNTRY_KEY = "ipCountryCode";

const segmentFromCountryCode = (countryCode) =>
  String(countryCode).toUpperCase() === "NG"
    ? PRICING_SEGMENT_LOCAL
    : PRICING_SEGMENT_DIASPORA;

// Remembers the IP-derived country so the first price request can already be segmented.
export const saveIpCountryCode = (countryCode) => {
  if (countryCode) localStorage.setItem(COUNTRY_KEY, countryCode);
};

// The service-prices currency is derived from the user's IP by the backend (NGN = in Nigeria).
export const savePricingSegmentFromCurrency = (currency) => {
  if (!currency) return;
  localStorage.setItem(
    SEGMENT_KEY,
    String(currency).toUpperCase() === "NGN"
      ? PRICING_SEGMENT_LOCAL
      : PRICING_SEGMENT_DIASPORA,
  );
};

export const getPricingSegment = () => {
  const countryCode = localStorage.getItem(COUNTRY_KEY);
  if (countryCode) return segmentFromCountryCode(countryCode);
  return localStorage.getItem(SEGMENT_KEY) === PRICING_SEGMENT_DIASPORA
    ? PRICING_SEGMENT_DIASPORA
    : PRICING_SEGMENT_LOCAL;
};
